import { render, staticRenderFns } from "./ticketing_data.vue?vue&type=template&id=63bc1150&"
import script from "./ticketing_data.vue?vue&type=script&lang=js&"
export * from "./ticketing_data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports